import { Skeleton } from '@repo/ui/platoo';
import React from 'react';

export const SkeletonBusinessDetailLoading = () => {
  return (
    <>
      <div className="flex gap-4 pt-6">
        <Skeleton className="h-[340px] w-full lg:w-[560px]" />
        <Skeleton className="hidden h-[340px] lg:block lg:w-[560px]" />
        <Skeleton className="hidden h-[340px] lg:block lg:w-[560px]" />
      </div>
      <div className="pt-14" />
      <Skeleton className="h-[48px] w-[500px]" />
      <Skeleton className="mt-3 h-[24px] lg:w-[800px]" />

      <Skeleton className="mt-3 h-[48px] lg:w-[200px]" />
      <Skeleton className="mt-3 h-[121px] lg:w-[710px]" />
      <Skeleton className="mt-3 h-[121px] lg:w-[710px]" />
    </>
  );
};

export const SkeletonBusinessesLoading = () => {
  return (
    <>
      <div className="flex flex-col gap-4">
        <Skeleton className="h-[43px] w-[200px]" />
        <Skeleton className="h-[43px] w-[400px]" />
      </div>
      <div className="mt-20 flex flex-col gap-4">
        <Skeleton className="h-[24px] w-[200px]" />
        <Skeleton className="h-[176px] w-full" />
      </div>

      <div className="mt-20 flex flex-col gap-4">
        <Skeleton className="h-[24px] w-[200px]" />
        <div className="flex flex-wrap gap-9">
          {Array.from({ length: 4 }).map((_) => (
            <Skeleton className="h-[240px] w-[300px]" />
          ))}
        </div>
      </div>

      <div className="mt-20 flex flex-col gap-4">
        <Skeleton className="h-[24px] w-[200px]" />
        <div className="grid grid-cols-3 gap-9">
          {Array.from({ length: 3 }).map((_) => (
            <Skeleton className="h-[110px] w-full" />
          ))}
        </div>
      </div>
    </>
  );
};
